
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AcceptFollowRequestOutput": [
      "AcceptFollowRequestSuccess",
      "AuthenticationError",
      "DuplicateAcceptFollowRequest",
      "FollowCommonRequestFailed",
      "NotFoundOpponentUser",
      "UnknownError"
    ],
    "AccessorAuthOutput": [
      "AccessorAuth",
      "AuthenticationError",
      "ForbiddenError",
      "UnknownError"
    ],
    "Awards": [
      "NaverBookingAwards",
      "NaverMyStyleAwards"
    ],
    "BaseError": [
      "AuthenticationError",
      "BlockUser_Duplicated",
      "BlockUser_Limit",
      "BlockUser_MySelf",
      "CleanBotError",
      "ConflictError",
      "ConnectionArgsError",
      "CreateReviewGroup_Duplicated",
      "CreateReviewGroup_NoContent",
      "CreateReviewGroup_SelectedProofNotFound",
      "DeleteReviewGroup_ReviewGroupNotFound",
      "DuplicateAcceptFollowRequest",
      "DuplicateCancelFollowRequest",
      "DuplicateFollowRequest",
      "DuplicateNicknameError",
      "DuplicatedError",
      "EntityError",
      "FollowCommonRequestFailed",
      "ForbiddenError",
      "FutureDateError",
      "IllegalVideo",
      "InspectedImageError",
      "InvalidDateTimeError",
      "InvalidImageUrlError",
      "InvalidIntroductionError",
      "InvalidNicknameError",
      "InvalidPastDateError",
      "MaxCacheCountError",
      "MaxProofError",
      "MeError",
      "Me_NotLoginError",
      "Me_UserNotFoundError",
      "MobileAppOnlyError",
      "NotExperimentTarget",
      "NotFoundError",
      "NotFoundOpponentUser",
      "NotSupportedSDKVersionError",
      "OverseasAttractionRecommends_Failed",
      "OverseasHotelRecommends_Failed",
      "PlaybackFailed",
      "PwordError",
      "ReceiptAuthenticationError",
      "ReceiptNotFound",
      "ReviewGroupKeywordNotValid",
      "ReviewGroupNotFound",
      "ReviewGroupOverflowMaxKeywordCount",
      "ReviewGroupOverflowMaxTextLength",
      "ReviewGroupWriteStat_ReviewGroupNotFound",
      "ReviewGroupWriteStat_TimeOver",
      "TrailerFailed",
      "UnblockUser_NotFound",
      "UnknownError",
      "UpdateGreyUserUnavailableFailed",
      "UpdateReviewGroup_NoContent",
      "UpdateReviewGroup_ReviewGroupNotFound",
      "UpdateReviewGroup_SelectedProofNotFound",
      "UpdateSubscribedLocations_Failed",
      "User_Failed",
      "VideoDownloadFailed",
      "VisitByBookingId_NotFound",
      "Visit_NotFound"
    ],
    "BlockUserOutput": [
      "BlockUser_Duplicated",
      "BlockUser_Limit",
      "BlockUser_MySelf",
      "BlockUser_Succeed",
      "UnknownError"
    ],
    "CancelFollowOutput": [
      "AuthenticationError",
      "CancelFollowSuccess",
      "FollowCommonRequestFailed",
      "NotFoundOpponentUser",
      "UnknownError"
    ],
    "CancelFollowRequestOutput": [
      "AuthenticationError",
      "CancelFollowRequestSuccess",
      "DuplicateCancelFollowRequest",
      "FollowCommonRequestFailed",
      "NotFoundOpponentUser",
      "UnknownError"
    ],
    "CardOutput": [
      "AuthenticationError",
      "Card_Succeed",
      "PaySession_Failed",
      "UnknownError"
    ],
    "CardPaymentAccessOutput": [
      "AuthenticationError",
      "CardPaymentAccess",
      "UnknownError"
    ],
    "CategoriesByLocationOutput": [
      "CategoriesByLocationSucceed",
      "UnknownError"
    ],
    "CheckIn": [
      "LocationCheckIn",
      "MediaCheckIn",
      "SearchCheckIn"
    ],
    "CreateLocationCheckInOutput": [
      "AuthenticationError",
      "LocationCheckIn",
      "MobileAppOnlyError",
      "UnknownError"
    ],
    "CreateMediaCheckInOutput": [
      "AuthenticationError",
      "MediaCheckIn",
      "MobileAppOnlyError",
      "UnknownError"
    ],
    "CreateOrUpdateReviewGroupReplyOutput": [
      "AuthenticationError",
      "CreateOrUpdateReviewGroupReplySucced",
      "ForbiddenError",
      "UnknownError"
    ],
    "CreateReceiptOutput": [
      "EnrichedPostReceipt",
      "PostFaultReceipt"
    ],
    "CreateReviewGroupOutput": [
      "AuthenticationError",
      "CleanBotError",
      "CreateReviewGroup_Duplicated",
      "CreateReviewGroup_NoContent",
      "CreateReviewGroup_SelectedProofNotFound",
      "CreateReviewGroup_Succeed",
      "MobileAppOnlyError",
      "ReviewGroupKeywordNotValid",
      "ReviewGroupOverflowMaxKeywordCount",
      "ReviewGroupOverflowMaxTextLength",
      "UnknownError"
    ],
    "CreateReviewGroupReportOutput": [
      "AuthenticationError",
      "CreateReviewGroupReportSucced",
      "DuplicatedError",
      "ForbiddenError",
      "UnknownError"
    ],
    "CreateSearchCheckInOutput": [
      "AuthenticationError",
      "MobileAppOnlyError",
      "SearchCheckIn",
      "UnknownError"
    ],
    "CreateThemelistOutput": [
      "AuthenticationError",
      "CreateThemelistSucceed",
      "UnknownError"
    ],
    "CreateVisitOutput": [
      "AuthenticationError",
      "CreateVisit_Succeed",
      "DuplicatedError",
      "EntityError",
      "ForbiddenError",
      "FutureDateError",
      "InvalidDateTimeError",
      "InvalidPastDateError",
      "MaxProofError",
      "MobileAppOnlyError",
      "UnknownError"
    ],
    "DeleteClipOutput": [
      "AuthenticationError",
      "DeleteClip_Succeed",
      "ForbiddenError",
      "UnknownError"
    ],
    "DeleteReviewGroupOutput": [
      "AuthenticationError",
      "DeleteReviewGroup_ReviewGroupNotFound",
      "DeleteReviewGroup_Succeed",
      "ForbiddenError",
      "UnknownError"
    ],
    "DeleteReviewGroupReplyOutput": [
      "AuthenticationError",
      "DeleteReviewGroupReplySucceed",
      "ForbiddenError",
      "UnknownError"
    ],
    "DeleteThemelistOutput": [
      "AuthenticationError",
      "DeleteThemelist_Succeed",
      "ForbiddenError",
      "NotFoundError",
      "UnknownError"
    ],
    "DeleteVisitOutput": [
      "AuthenticationError",
      "DeleteVisit_Succeed",
      "ForbiddenError",
      "UnknownError",
      "Visit_NotFound"
    ],
    "Edge": [
      "ReviewGroupEdge"
    ],
    "FeedsOutput": [
      "Feeds_Succeed",
      "UnknownError"
    ],
    "FollowRequestOutput": [
      "AuthenticationError",
      "DuplicateFollowRequest",
      "FollowCommonRequestFailed",
      "FollowRequestSuccess",
      "NotFoundOpponentUser",
      "UnknownError"
    ],
    "FollowingUsersFeedsOnOtherLocationsOutput": [
      "FollowingUsersFeedsOnOtherLocationsSucceed",
      "UnknownError"
    ],
    "HideVisitOutput": [
      "AuthenticationError",
      "ForbiddenError",
      "HideVisitSucceed",
      "MaxCacheCountError",
      "NotFoundError",
      "UnknownError"
    ],
    "IncreaseReviewGroupsViewOutput": [
      "IncreaseReviewGroupsViewsSucced",
      "UnknownError"
    ],
    "IncreaseThemelistViewOutput": [
      "IncreaseThemelistViewSucceed",
      "UnknownError"
    ],
    "LineAppNotificationsOutput": [
      "LineAppNotificationsSuccess",
      "UnknownError"
    ],
    "Location": [
      "CommonRecommendedLocation",
      "InterestingLocation",
      "NormalLocation",
      "PersonalRecommendedLocation"
    ],
    "MePayload": [
      "MeError",
      "MeSucceed",
      "Me_NotLoginError",
      "Me_UserNotFoundError"
    ],
    "MediaItem": [
      "ImageItem",
      "VideoItem"
    ],
    "MissionActivity": [
      "EmptyMissionActivity",
      "StampGroupMissionActivity",
      "StampMissionActivity"
    ],
    "MissionGroup": [
      "SingleMissionGroup",
      "StepMissionGroup"
    ],
    "MissionGroupsOutput": [
      "MissionGroupsSucceed",
      "UnknownError"
    ],
    "MissionReward": [
      "NPayMissionReward",
      "ProfileBorderMissionReward"
    ],
    "MissionStampProof": [
      "ReviewGroupProof"
    ],
    "MyVisitsOutput": [
      "ForbiddenError",
      "MyVisitsSucceed",
      "UnknownError"
    ],
    "OtherUsersFeedsOnLocationOutput": [
      "OtherUsersFeedsOnLocationSucceed",
      "UnknownError"
    ],
    "OverseasAttractionRecommendsOutput": [
      "OverseasAttractionRecommends_Failed",
      "OverseasAttractionRecommends_Succeed"
    ],
    "OverseasHotelRecommendsOutput": [
      "OverseasHotelRecommends_Failed",
      "OverseasHotelRecommends_Succeed"
    ],
    "OverwriteTagsOutput": [
      "AuthenticationError",
      "UnknownError",
      "UpdateTagsSucceed"
    ],
    "PaymentDeleteOutput": [
      "AuthenticationError",
      "PaymentDelete_Succeed",
      "UnknownError"
    ],
    "PaymentJobOutput": [
      "AuthenticationError",
      "ConflictError",
      "ForbiddenError",
      "NotFoundError",
      "PaySession_Failed",
      "PaymentJob",
      "UnknownError"
    ],
    "PaymentOutput": [
      "AuthenticationError",
      "ForbiddenError",
      "PaymentEdge",
      "UnknownError"
    ],
    "PaymentsOutput": [
      "AuthenticationError",
      "PaySession_Failed",
      "Payments_Succeed",
      "UnknownError"
    ],
    "PlaceOtherReviewGroupsOutput": [
      "ReviewGroupConnection",
      "UnknownError"
    ],
    "PlaybackOutput": [
      "IllegalVideo",
      "PlaybackFailed",
      "PlaybackSucceed"
    ],
    "Proof": [
      "BookingProof",
      "CheckInProof",
      "HotelProof",
      "PaymentProof",
      "ReceiptProof",
      "SelectableProof",
      "TrainTicketProof"
    ],
    "ReactReviewGroupOutput": [
      "AuthenticationError",
      "ReactReviewGroupSucceed",
      "UnknownError"
    ],
    "ReceiptAuthenticationOutput": [
      "ReceiptAuthentication",
      "ReceiptAuthenticationError"
    ],
    "ReceiptOutput": [
      "Receipt",
      "ReceiptNotFound"
    ],
    "RecentVisitsWithoutReviewOutput": [
      "RecentVisitsWithoutReview_Succeed",
      "UnknownError"
    ],
    "RecommendationForSubscriptableRegionsOutput": [
      "AuthenticationError",
      "RecommendationForSubscriptableRegionsSucceed",
      "UnknownError"
    ],
    "RejectFollowRequestOutput": [
      "AuthenticationError",
      "FollowCommonRequestFailed",
      "NotFoundOpponentUser",
      "RejectFollowRequestSuccess",
      "UnknownError"
    ],
    "ReportProofOutput": [
      "AuthenticationError",
      "ReportProofSucceed",
      "UnknownError"
    ],
    "ReviewGroupCategory": [
      "ReviewGroupAllCategory",
      "ReviewGroupPlaceCategory",
      "ReviewGroupRegionCategory"
    ],
    "ReviewGroupOutput": [
      "ReviewGroupNotFound",
      "ReviewGroupSucceed"
    ],
    "ReviewGroupWriteStatOutput": [
      "AuthenticationError",
      "ForbiddenError",
      "ReviewGroupWriteStat_ReviewGroupNotFound",
      "ReviewGroupWriteStat_Succeed",
      "ReviewGroupWriteStat_TimeOver",
      "UnknownError"
    ],
    "ReviewGruopReactionsOutput": [
      "ReviewGroupReactionsConnection",
      "UnknownError"
    ],
    "ReviewWriteUIConfigOutput": [
      "ReviewWriteUIConfigSucceed",
      "UnknownError"
    ],
    "ReviewersAroundRegionOutput": [
      "ReviewersAroundRegionSucceed",
      "UnknownError"
    ],
    "ReviewersOnCategoryOutput": [
      "ReviewersOnCategorySucceed",
      "UnknownError"
    ],
    "ReviewersWithSimilarTasteOutput": [
      "ReviewersWithSimilarTasteSucceed",
      "UnknownError"
    ],
    "SearchLocationsOutput": [
      "AuthenticationError",
      "SearchLocationsSucceed",
      "UnknownError"
    ],
    "SelectableProofsForReviewWriteByReviewGroupOutput": [
      "AuthenticationError",
      "ForbiddenError",
      "NotSupportedSDKVersionError",
      "SelectableProofsForReviewWriteByReviewGroupSucceed",
      "UnknownError"
    ],
    "SelectableProofsForReviewWriteByVisitOutput": [
      "AuthenticationError",
      "ForbiddenError",
      "NotSupportedSDKVersionError",
      "SelectableProofsForReviewWriteByVisitSucceed",
      "UnknownError"
    ],
    "SignUpOutput": [
      "AuthenticationError",
      "ForbiddenError",
      "NotFoundError",
      "SignUp_Succeed",
      "UnknownError"
    ],
    "StaticMapOutput": [
      "StaticMapSucceed",
      "UnknownError"
    ],
    "SubscribedLocationsOutput": [
      "AuthenticationError",
      "SubscribedLocationsSucceed",
      "UnknownError"
    ],
    "TagCountOutput": [
      "AuthenticationError",
      "TagCountSucceed",
      "UnknownError"
    ],
    "TagsOutput": [
      "AuthenticationError",
      "ConnectionArgsError",
      "TagsSucceed",
      "UnknownError"
    ],
    "ThemelistOutput": [
      "NotFoundError",
      "ThemelistSucceed",
      "UnknownError"
    ],
    "ThemelistsByRegionCodesOutput": [
      "ThemelistsByRegionCodesSucceed",
      "UnknownError"
    ],
    "TrackEventOutput": [
      "AuthenticationError",
      "NotExperimentTarget",
      "TrackEvent_Succeed",
      "UnknownError"
    ],
    "TrailerOutput": [
      "TrailerFailed",
      "TrailerSucceed"
    ],
    "UnblockUserOutput": [
      "UnblockUser_NotFound",
      "UnblockUser_Succeed",
      "UnknownError"
    ],
    "UpdateAutoAcceptFollowOutput": [
      "AuthenticationError",
      "UnknownError",
      "UpdateAutoAcceptFollowSuccess"
    ],
    "UpdateBookingTalkAlarmAgreedOutput": [
      "AuthenticationError",
      "UnknownError",
      "UpdateBookingTalkAlarmAgreedSuccess"
    ],
    "UpdateGreyUserUnavailableOutput": [
      "AuthenticationError",
      "UpdateGreyUserUnavailableFailed",
      "UpdateGreyUserUnavailableSucceed"
    ],
    "UpdateMyProfileOutput": [
      "DuplicateNicknameError",
      "InspectedImageError",
      "InvalidImageUrlError",
      "InvalidIntroductionError",
      "InvalidNicknameError",
      "PwordError",
      "UpdateMyProfileSucceed"
    ],
    "UpdateReviewGroupOutput": [
      "AuthenticationError",
      "CleanBotError",
      "ForbiddenError",
      "MobileAppOnlyError",
      "ReviewGroupKeywordNotValid",
      "ReviewGroupOverflowMaxKeywordCount",
      "ReviewGroupOverflowMaxTextLength",
      "UnknownError",
      "UpdateReviewGroup_NoContent",
      "UpdateReviewGroup_ReviewGroupNotFound",
      "UpdateReviewGroup_SelectedProofNotFound",
      "UpdateReviewGroup_Succeed"
    ],
    "UpdateSubscribedLocationsOutput": [
      "AuthenticationError",
      "UpdateSubscribedLocations_Failed",
      "UpdateSubscribedLocations_Succeed"
    ],
    "UserOutput": [
      "User_Failed",
      "User_Succeed"
    ],
    "UserReactionStatOutput": [
      "AuthenticationError",
      "ReactionStatSucceed",
      "UnknownError"
    ],
    "UserReactionsOutput": [
      "AuthenticationError",
      "UnknownError",
      "UserReactionsConnection"
    ],
    "UserRelationshipsOutput": [
      "ForbiddenError",
      "UnknownError",
      "UserRelationshipsSucceed"
    ],
    "UserReviewGroupsOutput": [
      "EntityError",
      "UnknownError",
      "UserReviewGroupsConnection"
    ],
    "UsersOutput": [
      "UnknownError",
      "Users_Succeed"
    ],
    "VariantOutput": [
      "AuthenticationError",
      "NotExperimentTarget",
      "UnknownError",
      "Variant"
    ],
    "VideoDownloadOutput": [
      "VideoDownloadFailed",
      "VideoDownloadSucceed"
    ],
    "VisitByBookingIdOutput": [
      "AuthenticationError",
      "UnknownError",
      "VisitByBookingId_NotFound",
      "VisitByBookingId_Succeed"
    ],
    "VisitOutput": [
      "AuthenticationError",
      "ForbiddenError",
      "UnknownError",
      "Visit_NotFound",
      "Visit_Succeed"
    ],
    "WorthPlacesOutput": [
      "UnknownError",
      "WorthPlacesSucceed"
    ],
    "XbuGlobalPlace": [
      "HotelPlace"
    ]
  }
};
      export default result;
    